module.exports = __webpack_public_path__ + "img/logo_1080.dfc2be61.png";